import AbstractModuleFactory from '@core/shared/module-factory';
import GetAllCampaignsUseCase from './use-cases/GetAllCampaigns';
import GetCampaignByIdUseCase from './use-cases/GetCampaignById';
import CampaignJoinRequestUseCase from './use-cases/CampaignJoinRequest';
import { IGetAllCampaignsUseCase, IGetCampaignByIdUseCase } from './interfaces';

export class CampaignModuleFactory extends AbstractModuleFactory {
  /**
   * Use case that handle the campaigns use case
   */
  createGetAllCampaignsUseCase(): IGetAllCampaignsUseCase {
    return this.ensureInstance('GetAllCampaignsUseCase', () => new GetAllCampaignsUseCase());
  }

  /**
   * Use case that handle the campaigns use case
   */
  createGetCampaignByIdUseCase(): IGetCampaignByIdUseCase {
    return this.ensureInstance('GetCampaignByIdUseCase', () => new GetCampaignByIdUseCase());
  }

  createCampaignJoinRequestUseCase(): CampaignJoinRequestUseCase {
    return this.ensureInstance('CampaignJoinRequestUseCase', () => new CampaignJoinRequestUseCase());
  }

  static new(): CampaignModuleFactory {
    return new CampaignModuleFactory();
  }
}

export default CampaignModuleFactory.new();
